<template>
  <div
    class="svg-text-button"
    :class="{ active }"
    @click="onClick">
    <InlineSvg
      :src="src"
      class="svg-text-button__icon" />
    <span
      class="svg-text-button__text"
      :class="[`fs-${fontSize}` , { 'font-weight-bold': bold }]">
      <slot />
    </span>
  </div>
</template>

<script>
import InlineSvg from 'vue-inline-svg'
export default {
  components: {
    InlineSvg
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: true
    },
    bold: {
      type: Boolean,
      default: false
    },
    fontSize: {
      type: String,
      default: 'm'
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.svg-text-button {
  display: flex;
  align-items: center;
  color: $grey05;
  cursor: pointer;

  &.active {
    color: $l-blue;
  }

  &__icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
    fill: currentColor;
  }

  &__text {
  }
}

</style>